"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var updateTemplate_1 = require("../../services/cart/updateTemplate");
var HandleAlert_1 = require("../../../../../common/js/services/alert/HandleAlert");
var CartSidebar = /** @class */ (function (_super) {
    __extends(CartSidebar, _super);
    function CartSidebar($view) {
        var _this = _super.call(this, $view) || this;
        _this.initListeners();
        return _this;
    }
    CartSidebar.prototype.getCGVSelector = function () {
        return '#accept_cgv';
    };
    CartSidebar.prototype.initListeners = function () {
        var _this = this;
        this.initCGV();
        this.initNextStep();
        this.initAddPromoCode();
        this.$view.on('click', '.promo-code .close a', function () {
            alert('remove code');
        });
        document.querySelector(".step_1")
            .addEventListener('shown.bs.tab', function () { return _this.showButtonNextStep(); });
        document.querySelector(".step_2")
            .addEventListener('shown.bs.tab', function () { return _this.showButtonNextStep(); });
        document.querySelector(".step_3")
            .addEventListener('shown.bs.tab', function () { return _this.showPaymentsMeans(); });
    };
    CartSidebar.prototype.showPaymentsMeans = function () {
        this.$view.find('#paiements_means').removeClass("d-none");
        this.$view.find('#next_step_row').addClass("d-none");
    };
    CartSidebar.prototype.showButtonNextStep = function () {
        this.$view.find('#paiements_means').addClass("d-none");
        this.$view.find('#next_step_row').removeClass("d-none");
    };
    CartSidebar.prototype.initNextStep = function () {
        var _this = this;
        this.$view.on('click', "#next_step", function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el, route;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                route = $el.data('route_update');
                window.HegydCore.sendRequest(route, 'PUT', {
                    'update_cart': true,
                    'next_step': true,
                }, function (data) {
                    window.location.reload();
                }, function (_a) {
                    var responseJSON = _a.responseJSON;
                    // echec
                    if (responseJSON !== undefined) {
                        (0, HandleAlert_1.errorAlert)(responseJSON.message);
                    }
                });
                return [2 /*return*/];
            });
        }); });
    };
    CartSidebar.prototype.initAddPromoCode = function () {
        var _this = this;
        this.$view.on('click', '.promo-code-input button', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                $('#no_valide_code').addClass('d-none');
                window.HegydCore.sendRequest($('input[name="promocode"]').data('route_update'), 'POST', {
                    'update_cart': true,
                    'code': $('input[name="promocode"]').val(),
                    'return_templates': ['sidebar'],
                }, function (data) {
                    _this.updateCartViews(data);
                }, function (_a) {
                    var responseJSON = _a.responseJSON;
                    // echec
                    if (responseJSON !== undefined) {
                        $('#no_valide_code').removeClass('d-none');
                    }
                });
                return [2 /*return*/];
            });
        }); });
    };
    CartSidebar.prototype.initCGV = function () {
        var _this = this;
        this.$view.on('change', this.getCGVSelector(), function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                window.HegydCore.sendRequest($el.data('route_update'), 'PUT', {
                    'update_cart': true,
                    'accept_cgv': $el.prop('checked'),
                    'return_templates': ['sidebar'],
                }, function (data) {
                    _this.updateCartViews(data);
                });
                return [2 /*return*/];
            });
        }); });
    };
    CartSidebar.prototype.updateCartViews = function (data) {
        (0, updateTemplate_1.default)(data);
        // this.initListeners();
    };
    CartSidebar.currentStep = function () {
        return parseInt($('.nav .nav-link.active .step-number').html(), 10);
    };
    return CartSidebar;
}(BaseComponent_1.default));
exports.default = CartSidebar;
